import React from "react";
import { Offcanvas, Table } from "react-bootstrap";
import Moment from "react-moment";

const ProjectFileProperties = ({ tableRef, onMouseDown, Show, Hide, Title, projectData }) => {
  return (
    <div>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 600 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Attribute</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">1.</td>
                <td>File Name</td>
                <td>{projectData?.name}</td>
              </tr>
              <tr>
                <td className="text-center">2.</td>
                <td>Extension</td>
                <td>.{projectData?.extension}</td>
              </tr>
              <tr>
                <td className="text-center">3.</td>
                <td>Location</td>
                <td title={`${projectData?.path}${projectData?.type === "file" && `.${projectData?.extension}`}`}>
                  {projectData?.path}{projectData?.type === "file" && `.${projectData?.extension}`}
                </td>
              </tr>
              <tr>
                <td className="text-center">4.</td>
                <td>Created Date | Time</td>
                <td>
                  <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                    {projectData?.createdAt}
                  </Moment>
                </td>
              </tr>
              <tr>
                <td className="text-center">5.</td>
                <td>Modified Date | Time</td>
                <td>
                  <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                    {projectData?.updatedAt}
                  </Moment>
                </td>
              </tr>
            </tbody>
          </Table>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default ProjectFileProperties;
